import React from 'react';

type InputProps = {
  senderName: string | null | undefined;
  recipientName: string | null | undefined;
  subject: string | null | undefined;
  formattedSendDateTime: string;
};

export const EmailMessageHeader = (props: InputProps) => {
  const { senderName, recipientName, subject, formattedSendDateTime } = props;

  if (!senderName) {
    return null;
  }

  return (
    <div className="typo-subtitle u-display-flex u-justifyContent-spaceBetween u-flexGrow-1">
      <div>
        <div>From: {senderName}</div>
        <div>To: {recipientName}</div>
        <div>Subject: {subject}</div>
      </div>
      <div>{formattedSendDateTime}</div>
    </div>
  );
};
